export const generateCookie = (): string => {
  return window.env.REACT_APP_CODE_VERSION.substring(
    0,
    window.env.REACT_APP_CODE_VERSION.lastIndexOf('.'),
  );
};
